module.exports = __webpack_public_path__ + "media/swipetable-grayscale-cropped.a095f251.mp4";